import React, { Fragment, useState } from "react";
import { withAuth } from "./AuthContext";
import { Link, withRouter } from "react-router-dom";

const Auth0Test = () => {
    console.log()

    return (
        <section className="contact-wrapper">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <button
                            onClick={() => {
                                window.location.replace('http://localhost:57331/auth0/login');
                            }}
                        >Log In</button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default withRouter(withAuth(Auth0Test));
